import { createReducer } from "typesafe-actions";

import {
  Actions,
  applyRouteRecordsListSettings,
  fetchRouteLassoRecords,
  fetchRouteMultiPinRecords,
  hideRouteMultiPin,
  setRouteListViewLocationSortQuery,
  showRouteMultiPinRecords,
} from "../../actions";
import { initialMapState, RouteMapState } from "../state";

export const recordsReducer = createReducer<RouteMapState, Actions>(initialMapState)
  .handleAction(showRouteMultiPinRecords.request, (state, { payload }) => ({
    ...state,
    recordsList: {
      ...state.recordsList,
      multiPin: { address: undefined, entity: payload },
      records: [],
      search: undefined,
      totalRecords: 0,
    },
  }))
  .handleAction(showRouteMultiPinRecords.success, (state, { payload }) => ({
    ...state,
    recordsList: {
      ...state.recordsList,
      multiPin: state.recordsList.multiPin
        ? { ...state.recordsList.multiPin, address: payload.address }
        : { address: payload.address },
    },
  }))
  .handleAction(hideRouteMultiPin, (state) => ({
    ...state,
    recordsList: {
      ...state.recordsList,
      multiPin: undefined,
      records: [],
      search: undefined,
      totalRecords: 0,
    },
  }))
  .handleAction(fetchRouteMultiPinRecords.request, (state, { payload }) => ({
    ...state,
    recordsList: {
      ...state.recordsList,
      loading: true,
      range: payload.range ?? state.recordsList.range,
      search: payload.search !== undefined ? payload.search : state.recordsList.search,
    },
  }))
  .handleAction(fetchRouteMultiPinRecords.success, (state, { payload }) => ({
    ...state,
    recordsList: {
      ...state.recordsList,
      loading: false,
      records: payload.records,
      totalRecords: payload.count,
    },
  }))
  .handleAction(fetchRouteMultiPinRecords.failure, (state) => ({
    ...state,
    recordsList: { ...state.recordsList, loading: false },
  }))
  .handleAction(fetchRouteLassoRecords.request, (state, { payload }) => ({
    ...state,
    recordsList: {
      ...state.recordsList,
      loading: true,
      range: payload.range ?? state.recordsList.range,
      search: payload.search !== undefined ? payload.search : state.recordsList.search,
    },
  }))
  .handleAction(fetchRouteLassoRecords.success, (state, { payload }) => ({
    ...state,
    recordsList: {
      ...state.recordsList,
      loading: false,
      records: payload.records,
      totalRecords: payload.totalRecords,
    },
  }))
  .handleAction(fetchRouteLassoRecords.failure, (state) => ({
    ...state,
    recordsList: { ...state.recordsList, loading: false },
  }))
  .handleAction(applyRouteRecordsListSettings, (state, { payload }) => ({
    ...state,
    recordsList: {
      ...state.recordsList,
      sort: payload.sort ?? state.recordsList.sort,
    },
  }))
  .handleAction(setRouteListViewLocationSortQuery, (state, { payload }) => ({
    ...state,
    recordsList: { ...state.recordsList, query: payload },
  }));

export default recordsReducer;
